export default __webpack_public_path__ + "static/media/logo-space.cf4f9ddc.png";